export default [
  {
    name: '年交',
    value: '0'
  }
]



// WEBPACK FOOTER //
// ./src/data/paymentMethods.js